import {Redirect, Route, Switch} from 'react-router-dom';
import {getConfig} from '../../util/configUtil';
import LiteDashboard from '../../pages/insight/lite/liteDashboard';

function DashboardRoutes({match}) {
    const isInsightEnabled = getConfig('modules.insightDashboard.enabled');
    return (
        <Switch>
            {isInsightEnabled &&
                <>
                    <Route exact path={match.path} component={TestComponent}/>
                    <Route path={`${match.path}/create`} component={TestComponent}/>
                </>
            }

            {!isInsightEnabled &&
                <Route exact path={match.path} component={LiteDashboard}/>
            }
            <Route path={`${match.path}/lite`} component={LiteDashboard}/>
            <Redirect to={match.path}/>
        </Switch>
    );
}


export default DashboardRoutes;

function TestComponent() {
    return (
        <div>
            <h1>Test Component {Math.random()}</h1>
        </div>
    );
}